import type { heiliaoVideos } from '@/mocks/home';

interface VideoSectionProps {
  videos: typeof heiliaoVideos;
}

export default function VideoSection({ videos }: VideoSectionProps) {
  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/20 text-background-50/70 text-xs font-medium mb-4">
              黑料视频专区
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-black text-background-50 leading-tight">
              独家黑料视频
              <span className="block text-xl md:text-2xl font-normal text-background-50/40 mt-1">
                实拍 · 录音 · 聊天记录
              </span>
            </h2>
          </div>
          <Link to="/category/heiliao-shipin"
            className="flex items-center gap-1.5 text-background-50/60 hover:text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-4 md:gap-6 overflow-x-auto pb-4 -mx-4 px-4 md:mx-0 md:px-0 scrollbar-hide"
          style={{ scrollSnapType: 'x mandatory' }}
        >
          {videos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.slug}`}
              className="flex-shrink-0 w-[280px] md:w-[320px] group cursor-pointer"
              style={{ scrollSnapAlign: 'start' }}
            >
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-video">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/60 text-background-50 text-xs">
                  {video.views} 次播放
                </div>
              </div>
              <div className="mt-3 px-1">
                <h3 className="text-background-50 text-sm font-semibold line-clamp-2 leading-snug group-hover:text-primary-400 transition-colors">
                  {video.title}
                </h3>
                <p className="mt-1 text-background-50/40 text-xs">{video.subtitle}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}